<script>
import EventBus from '~/EventBus'

import ShopifyReauthModal from './ShopifyReauthModal.vue'
import CloudflareChallenge from '~/components/cloudflare-challenge/CloudflareChallenge.vue'

import Loading from './Loading'

// Load layout components dynamically.
const layoutModules = import.meta.glob('../layouts/*.vue', { eager: true })

const layouts = Object.entries(layoutModules).reduce((components, [path, module]) => {
  const name = path.replace(/^.*\/(.*)\.vue$/, '$1')
  components[name] = module.default || module
  return components
}, {})

export default {
  el: '#app',

  components: {
    Loading,
    CloudflareChallenge,
    ShopifyReauthModal,
  },

  data: () => ({
    layout: null,
    defaultLayout: 'default',
    isShowCloudflareChallenge: false,
  }),

  metaInfo() {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`,
    }
  },

  mounted() {
    localStorage.setItem('activeTheme', 'light')
    EventBus.$on('show-cloudflare-challenge', this.showCloudflareChallenge)
    EventBus.$on('close-cloudflare-challenge', this.closeCloudflareChallenge)
    this.$loading = this.$refs.loading
  },

  methods: {
    showCloudflareChallenge() {
      this.isShowCloudflareChallenge = true
    },
    closeCloudflareChallenge() {
      this.isShowCloudflareChallenge = false
    },
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout(layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]

      //this.$session.start()
    },
    moveTooltip(e, { maxWidth = '375px', x = -15, y = 25, selector = '.moving-tooltip' }) {
      let target = e.target
      let tooltipbox = target.querySelector(selector)

      if (tooltipbox !== null) {
        tooltipbox.style.position = 'fixed'
        tooltipbox.style.top = `${e.clientY + y}px`
        tooltipbox.style.left = `${e.clientX + x}px`
        tooltipbox.style.maxWidth = maxWidth
      }
    },
  },
}
</script>

<template>
  <div id="app">
    <loading ref="loading" />

    <transition
      name="page"
      mode="out-in"
    >
      <component
        :is="layout"
        v-if="layout"
      />
    </transition>
    <cloudflare-challenge v-if="isShowCloudflareChallenge" />
    <shopify-reauth-modal />
  </div>
</template>
